/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commonrecord1Inputs */



/**
* | output |
* | --- |
* | "Record" |
*
* @param {Commonrecord1Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const commonrecord1 = /** @type {((inputs?: Commonrecord1Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commonrecord1Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Record")
	if (locale === "es") return /** @type {LocalizedString} */ ("Grabar")
	return /** @type {LocalizedString} */ ("Запись")
});
export { commonrecord1 as "commonRecord" }